import { ReactElement, useCallback } from 'react';
import { Button, Popover, Select } from '@ff-it/ui';
import { useOptions } from 'components/fields';
import { useNavigate } from 'react-router';
import { popoverPanel } from 'components/TopNav.css';
import { EmbeddedSelect } from 'components/EmbeddedSelect';
import { Result } from './types';

const getOptionLabel = (a: Result): string => a.code;

export function GlobalSearch({ compact }: { compact?: boolean }): ReactElement {
  const navigate = useNavigate();

  const loadOptions = useOptions<any>('core/search/');

  const onChange = useCallback(
    (v: any) => {
      if (v) {
        if (v.kind === 'campaign') {
          navigate(`/${v.data.slug}/planning/campaigns/${v.data.id}/planning`);
        } else if (v.kind === 'block') {
          navigate(`/${v.data.campaign.slug}/planning/campaigns/${v.data.campaign.id}/planning/${v.data.id}`);
        }
      }
    },
    [navigate],
  );

  const selectProps = {
    loadOptions,
    getOptionLabel,
    onChange,
    value: null,
    name: 'global_search',
    id: 'global_search',
    placeholder: 'Code…',
    isClearable: false,
    noOptionsMessage: ({ inputValue }: { inputValue: string }) => (inputValue ? 'No matches' : 'Type to search'),
  };

  // compact: collapse to a magnifier icon popover with embedded select
  if (compact) {
    return (
      <Popover
        placement="bottom-end"
        content={
          <div className={popoverPanel}>
            <EmbeddedSelect<Result> {...selectProps} />
          </div>
        }
      >
        <Button variant="ghost" size="xs" icon="magnifying-glass" />
      </Popover>
    );
  }

  return (
    <div className="form-inline">
      <Select<Result> {...selectProps} size="sm" />
    </div>
  );
}
